// Fonction de tri des produits par disponibilité
function sortProductsByAvailability(products) {
  // Séparer les produits en stock et épuisés
  const inStock = [];
  const outOfStock = [];

  products.forEach(product => {
    if (product.available) {
      inStock.push(product);
    } else {
      outOfStock.push(product);
    }
  });

  // Combiner les produits en stock et épuisés, avec les produits en stock en premier
  return inStock.concat(outOfStock);
}

// Fonction pour afficher les produits triés
function displaySortedProducts() {
  const productElements = document.querySelectorAll('.product'); // Assure-toi d'avoir la bonne classe ou ID
  const products = [];

  productElements.forEach(productElement => {
    const product = {
      element: productElement,
      available: productElement.classList.contains('in-stock') // Vérifie si le produit est en stock (ajuste selon ta structure HTML)
    };
    products.push(product);
  });

  // Trier les produits par disponibilité
  const sortedProducts = sortProductsByAvailability(products);

  // Réorganiser les produits dans l'ordre trié
  const parentElement = document.querySelector('.product-list'); // Remplace par l'élément parent qui contient tous les produits
  sortedProducts.forEach(product => {
    parentElement.appendChild(product.element); // Réajuste l'ordre des éléments DOM
  });
}

// Exécuter la fonction de tri quand la page est chargée
document.addEventListener('DOMContentLoaded', displaySortedProducts);
